import * as React from 'react';
import Svg, { SvgProps, G, Path, Rect } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg width={30} height={32} {...props}>
      <G fill="none" fillRule="evenodd">
        <G transform="translate(0 19)">
          <Path d="M2 6a1 1 0 00-1 1v4a1 1 0 001 1h26a1 1 0 001-1V7a1 1 0 00-1-1H2z" stroke="#247A9C" strokeWidth={2} />
          <Rect fill="#247A9C" x={8} width={14.71} height={2.452} rx={1.226} />
        </G>
        <Path
          d="M15.487 0a1 1 0 011 1l-.001 14.772 4.96-4.867a.878.878 0 011.15-.07l.09.08.001.001.078.09a.874.874 0 01-.01 1.057l-.08.089-6.552 6.432a.876.876 0 01-.655.25.875.875 0 01-.653-.25l-6.553-6.432a.874.874 0 01-.01-1.237.878.878 0 011.24-.01l4.994 4.9V1a1 1 0 011-1z"
          fill="#247A9C"
        />
      </G>
    </Svg>
  );
}

const DepositIcon = React.memo(SvgComponent);
export default DepositIcon;
